import axios from 'axios';
import { IpDataModel } from '@/models/ip-data.model';

export const fetchIpData = async (): Promise<IpDataModel> => {
  const response = await axios.post('https://ipdata.lucky7cdn.com', null);
  return response.data;
};
